import React, { useState } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header';
import Dashboard from '../Dashboard/Dashboard';
import { UsersList, UserUpsertPage, UserViewPage, ChangePasswordPage } from '../../pages/Users/routes';
import { ClientsList, ClientUpsertPage, ClientViewPage } from '../../pages/Clients/routes';
import { ExercisesList, ExerciseUpsertPage, ExercisesViewPage } from '../../pages/Exercises/routes';
import { RoutinesList, RoutineUpsertPage } from '../../pages/Routines/routes';
import { ClientReportPage, PlanReportPage } from '../../pages/Reports/routes';
import { PreparationList, PreparationUpsertPage, PreparationViewPage } from '../../pages/Preparations/routes';
import GlobalLoading from '../Utility/GlobalLoading';
import './Sidebar/Sidebar.css';
import RoutineViewPage from '../../pages/Routines/RoutioneViewPage';

const Admin = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { loading } = useAuth();

  if (loading) return <GlobalLoading />;

  const contentClassNames = collapsed
    ? 'sidebar--collapsed absolute t-0 r-0 sidebar'
    : 'sidebar absolute t-0 r-0 ';

  return (
    <Layout>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className={contentClassNames}>
        <Header/>
        <main
          className="w-full"
          style={{
            backgroundColor: 'var(--sthenus-bg-main)',
            minHeight: 'calc(100vh - 56px)',
          }}
        >
          <Routes>
            {/* Ruta por defecto: Dashboard */}
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            
            {/* Rutas de Usuarios */}
            <Route path="/users/all" element={<UsersList />} />
            <Route path="/users/add" element={<UserUpsertPage />} />
            <Route path="/users/:id/edit" element={<UserUpsertPage />} />
            <Route path="/users/view/:id" element={<UserViewPage />} />
            <Route path="/users/:id/change-password" element={<ChangePasswordPage />} />
            
            {/* Rutas de Clientes */}
            <Route path="/clients/all" element={<ClientsList />} />
            <Route path="/clients/add" element={<ClientUpsertPage />} />
            <Route path="/clients/:id/edit" element={<ClientUpsertPage />} />
            <Route path="/clients/view/:id" element={<ClientViewPage />} />

            {/* Rutas de Ejercicios */}
            <Route path="/exercises/all" element={<ExercisesList />} />
            <Route path="/exercises/add" element={<ExerciseUpsertPage />} />
            <Route path="/exercises/:id/edit" element={<ExerciseUpsertPage />} />
            <Route path="/exercises/view/:id" element={<ExercisesViewPage />} />

            {/* Rutas de Calentamientos/Estiramientos */}
            <Route path="/preparations/all" element={<PreparationList />} />
            <Route path="/preparations/add" element={<PreparationUpsertPage />} />
            <Route path="/preparations/:id/edit" element={<PreparationUpsertPage />} />
            <Route path="/preparations/view/:id" element={<PreparationViewPage />} />

            {/* Rutas de Rutinas */}
            <Route path="/routines/all" element={<RoutinesList />} />
            <Route path="/routines/add" element={<RoutineUpsertPage />} />
            <Route path="/routines/:id/edit" element={<RoutineUpsertPage />} />
            <Route path="/routines/view/:id" element={<RoutineViewPage />} />

            {/* Reportes */}
            <Route path="/reports/clients" element={<ClientReportPage />} />
             <Route path="/reports/plans" element={<PlanReportPage />} />
            
            {/* Ruta catch-all: redirige al dashboard si la ruta no existe */}
            <Route path="*" element={<Dashboard />} />
          </Routes>
        </main>
      </div>
    </Layout>
  );
};

export default Admin;
